import React from "react";

/**
 * 2 Cards Teenpatti video title — reference markup (first child of .casino-video):
 * .casino-video-title > span.casino-name " " .casino-video-rid
 */
export default function Patti2VideoTitle({ title = "2 Cards Teenpatti", roundId }) {
  return (
    <div className="casino-video-title">
      <span className="casino-name">{title}</span>{" "}
      <div className="casino-video-rid">Round ID: {roundId}</div>
    </div>
  );
}
